<template lang="html">

<div class="game-template">
  <ul
    class="players"
    v-if="game"
  >
    <li
      class="player"
      v-for="(player, playerID) in game.players"
    >
      <div
        class="player-stats"
        :class="{'player-stats--gameover': gameOver}"
      >
        <div class="player-stats-top">
          <p class="player-name">{{player.name}}</p>
          <p
            class="player-score"
            :style="{'color': player.color}">
            {{currentScores && currentScores[playerID] ? currentScores[playerID].total : 0}}
          </p>
        </div>
        <div
          class="score-progress"
          :style="{
            'background-color': player.color,
            'width': getScorePercent(currentScores && currentScores[playerID] ? currentScores[playerID].total : 0) + '%'
          }">
        </div>
        <div class="player-stats-bottom">
          <p v-if="game.rounds"
              v-for="(round, id) in game.rounds"
              class="player-score-previous"
              :class="{
                'player-score-previous--yaniv': scores[id][playerID].yaniv && !scores[id][playerID].contre,
                'player-score-previous--contre': scores[id][playerID].contre,
                'player-score-previous--douche': scores[id][playerID].douche
              }"
          >
            <span
              class="player-score-previous_point"
              :style="scores[id][playerID].yaniv && !scores[id][playerID].contre ? {'background-color': player.color} : {}"
            >
              {{round[playerID]}}
            </span>
            <span
              class="player-score-previous_score"
              :style="{
                'color': player.color,
                'text-decoration': 'none'
              }"
            >
              {{scores[id][playerID].total}}
            </span>
          </p>
        </div>
      </div>
      <div
        class="button-yaniv ripple circle"
        :style="{'background-color': player.color}"
        @click="editScore(playerID)"
        v-show="!gameOver"
      >YANIV!</div>
    </li>
  </ul>
</div>

</template>

<script>
import gamesStore, { SCORE_MAX } from './../store/GamesStore'

export default {
  filters: {
    scorePercent(score) {
      return Math.round(score / SCORE_MAX * 100)
    },
  },
  data() {
    return {
      header: {
        rightIcon: 'icon-replay',
        rightAction: () => {
          const answer = confirm('Annuler le dernier coup ?')
          if (answer) {
            this.cancelRound()
            return true
          }
          return false
        }
      },
      scoreMax: SCORE_MAX,
    }
  },
  computed: {
    game() {
      return gamesStore.state.currentGame
    },
    scores() {
      return this.game ? this.game.scores : null
    },
    currentScores() {
      return this.game && this.game.scores ? this.game.scores[this.game.scores.length - 1] : 0
    },
    gameOver() {
      return gamesStore.state.currentGame.winnerID >= 0
    },
  },
  methods: {
    editScore(index) {
      this.game.setYanivID(index)
      this.$emit('onPushState', 'edit-score')
    },
    cancelRound() {
      this.game.removeLastRound()
    },
    getScorePercent(score) {
      return Math.round(score / SCORE_MAX * 100)
    }
  },
}
</script>

<style lang="stylus">

@import '../styles/common'

.game-template
  width 100%
  height 100%
  margin auto
  text-align left

  .players
    list-style none
    padding 0
    margin 0

  .player
    display flex
    box-sizing border-box
    padding 1em 0.7em
    position relative
    align-content center
    align-items flex-start
    justify-content space-between

  .player-stats
    display flex
    flex-direction column
    width calc(100% - 90px)
    &--gameover
      width 100%
    &-top
      display flex
      align-items center
    &-bottom
      display flex
      justify-content flex-end
      overflow hidden

  .player-name
    display block
    font-size 1.2em
    line-height normal
    overflow hidden
    text-overflow ellipsis

  .player-score
    display block
    font-size 1.5em
    font-weight bold
    margin-left auto

  .score-progress
    display block
    width 100%
    height 4px
    margin 10px 0
    background-color silver
    border-radius @height * 2

  .player-score-previous
    display inline-block
    flex-shrink 0
    vertical-align top
    font-size 0.9em
    font-weight 300
    color silver
    width 30px
    text-align center
    padding-top 3px
    span
      display block
      width 25px
      height @width
      line-height @width
      border-radius @width
    &--yaniv
      .player-score-previous_point
        color: #eee;
    &--contre
      .player-score-previous_point
        background-color alpha(lightcoral, 0.2)
    &--douche
      .player-score-previous_point
        background-color lightcyan
    &:last-child
      font-weight bold

  .button-yaniv
    font-weight bold
    line-height normal
    font-size 1em
    padding 0.7em
    cursor pointer
    border-radius 3px

</style>


// WEBPACK FOOTER //
// Game.vue?4c1dd32e